import { Theme } from '@mui/material';

export const getSpacing = (theme: Theme, spacing: number) =>
  Number(theme.spacing(spacing).slice(0, -2));
